module.exports = __webpack_public_path__ + "img/doge.b34afe80.svg";